const storage = {
    getItem: (name) => {
        if (typeof localStorage === 'undefined')
            return null;
        return localStorage.getItem(name);
    },
    setItem: (name, value) => {
        if (typeof localStorage === 'undefined')
            return;
        localStorage.setItem(name, value);
    },
    removeItem: (name) => {
        if (typeof localStorage === 'undefined')
            return;
        localStorage.removeItem(name);
    }
};
const persistenceConfig = {
    cart: {
        key: 'cart',
        statePaths: ['cart', 'total']
    },
    features: {
        key: 'features-store',
        statePaths: ['selectedFeatures']
    }
};
export const persistencePlugin = (store) => {
    store.subscribe((mutation, state) => {
        if (mutation.type.startsWith('cart/')) {
            const cartState = state.cart;
            const dataToSave = {
                state: {
                    cart: cartState.cart,
                    total: cartState.total
                }
            };
            storage.setItem('cart', JSON.stringify(dataToSave));
        }
        if (mutation.type.startsWith('features/')) {
            const featuresState = state.features;
            const dataToSave = {
                state: {
                    selectedFeatures: featuresState.selectedFeatures
                }
            };
            storage.setItem('features-store', JSON.stringify(dataToSave));
        }
    });
    if (typeof window !== 'undefined') {
        setTimeout(() => {
            store.dispatch('cart/loadFromStorage').catch(console.error);
            store.dispatch('features/loadFromStorage').catch(console.error);
        }, 100);
    }
};
export const createPersistencePlugin = (config) => {
    return (store) => {
        Object.keys(config).forEach(moduleName => {
            const moduleConfig = config[moduleName];
            store.subscribe((mutation, state) => {
                if (mutation.type.startsWith(`${moduleName}/`)) {
                    const moduleState = state[moduleName];
                    const dataToSave = { state: {} };
                    moduleConfig.statePaths.forEach((path) => {
                        if (moduleState[path] !== undefined) {
                            dataToSave.state[path] = moduleState[path];
                        }
                    });
                    storage.setItem(moduleConfig.key, JSON.stringify(dataToSave));
                }
            });
        });
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                Object.keys(config).forEach(moduleName => {
                    store.dispatch(`${moduleName}/loadFromStorage`).catch(console.error);
                });
            }, 100);
        }
    };
};
export { storage };
